<mat-dialog-content class="flex flex-column items-center gap-3">
  @if (image) {
    <img [src]="image" alt="dialog-image" class="dialog-image" />
  }

  <h2 mat-dialog-title class="text-center m-0">{{ data.title }}</h2>

  @if (data.message) {
    @if (isArray(data.message)) {
      @for (paragraph of data.message; track $index) {
        <p class="text-center">{{ paragraph }}</p>
      }
    } @else {
      <p class="text-center">{{ data.message }}</p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="flex justify-center gap-3 flex-column">
  @for (button of data.buttons; track button.value) {
    <app-button
      [variant]="button.variant ?? 'flat'"
      [mat-dialog-close]="button.value"
      [class]="button.class"
    >
      {{ button.label }}
    </app-button>
  }
</mat-dialog-actions>
